const localGetter = {
    getEnrollStudent(state) {
        return state.enrollstudent;
    },
    getEnroll(state) {
        return state.enroll;
    }
}

export default localGetter;



// WEBPACK FOOTER //
// ./src/store/jzjy/getters/localGetter.js